import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as loginRecordApi from '../../api/loginRecord';
import { message } from 'antd';

// 获取用户登录记录列表
export const fetchLoginRecords = createAsyncThunk(
  'loginRecord/fetchList',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await loginRecordApi.getLoginRecordList(params);
      if (response && response.code === 200) {
        // 返回数据和查询参数，以便在reducer中保存
        return {
          data: response.data,
          params
        };
      }
      return rejectWithValue(response?.message || '获取用户登录记录失败');
    } catch (error) {
      return rejectWithValue(error.message || '获取用户登录记录失败');
    }
  }
);

// 初始状态
const initialState = {
  // 用户登录记录列表
  loginRecordList: {
    data: [],
    total: 0,
    current: 1,
    size: 10,
    loading: false,
    error: null,
    searchParams: {
      userId: undefined,
      deviceId: undefined,
      status: undefined,
      loginType: undefined
    }
  }
};

// 创建Slice
const loginRecordSlice = createSlice({
  name: 'loginRecord',
  initialState,
  reducers: {
    setSearchParams: (state, action) => {
      state.loginRecordList.searchParams = {
        ...state.loginRecordList.searchParams,
        ...action.payload
      };
    }
  },
  extraReducers: (builder) => {
    builder
      // 处理获取用户登录记录列表
      .addCase(fetchLoginRecords.pending, (state) => {
        state.loginRecordList.loading = true;
        state.loginRecordList.error = null;
      })
      .addCase(fetchLoginRecords.fulfilled, (state, action) => {
        state.loginRecordList.loading = false;
        state.loginRecordList.data = action.payload.data.records || [];
        state.loginRecordList.total = action.payload.data.total || 0;
        state.loginRecordList.current = action.payload.data.current || 1;
        state.loginRecordList.size = action.payload.data.size || 10;
        
        // 保存搜索参数
        if (action.payload.params) {
          state.loginRecordList.searchParams = {
            ...state.loginRecordList.searchParams,
            ...action.payload.params
          };
        }
      })
      .addCase(fetchLoginRecords.rejected, (state, action) => {
        state.loginRecordList.loading = false;
        state.loginRecordList.error = action.payload;
        message.error(action.payload || '获取用户登录记录失败');
      });
  }
});

export const { setSearchParams } = loginRecordSlice.actions;

export default loginRecordSlice.reducer; 